export default __webpack_public_path__ + "static/avatar@2x-6805b9b824c9e1dd8c5e802cb5139d70.png";